import app from "js/legacy-app";

app.controller('ProfilePictureCtrl', ['$scope', '$location', function ($scope, $location) {
    $scope.onUploadImages = () => {
        $location.path('/dashboard');
    }
}]);